import { useIsMobile } from '@utils/hooks/useIsMobile';
import { Trans } from '@lingui/macro';
import { useState } from 'react';
import EnquiryForm from '@components/enquiry-form';
import Modal from 'react-modal';
import SlideUp from '@components/slide-up'

import './style.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark } from '@fortawesome/pro-regular-svg-icons';

Modal.setAppElement('#root');

const ContactModal = () => {
    const mobile = useIsMobile();

    const [isModalOpen, setIsModalOpen] = useState(false);
    const openModal = () => setIsModalOpen(true);
    const closeModal = () => setIsModalOpen(false);

    const [isSlideOpen, setSlideOpen] = useState(false);

    return (
        <div className="contact-modal">
            {mobile ? (
                <SlideUp 
                    header="Enquire about this trip" 
                    onOpen={() => setSlideOpen(true)}
                    open={isSlideOpen}
                    onClose={() => setSlideOpen(false)}
                >
                    <div className="btn"><Trans>Book Now</Trans></div>
                    <EnquiryForm closeSlideUp={setSlideOpen} />
                </SlideUp>
            ) : (
                <>
                    <button className='btn' onClick={openModal}>
                        <Trans>Book Now</Trans>
                    </button>
                    <Modal
                        className={'contact-modal-container'}
                        isOpen={isModalOpen}
                        onRequestClose={closeModal}
                        contentLabel="Enquiry Form"
                        style={{
                            overlay: {
                                zIndex: 9999,
                                background: '#534D6770',
                            },
                            content: {
                                padding: 0,
                                position: 'absolute',
                                inset: '40px',
                                border: '1px solid rgb(204,204,204)',
                                background: 'rgb(255, 255, 255)',
                                overflow: 'visible',
                                outline: 'none',
                                maxWidth: '1840px',
                                maxHeight: '1000px',
                                margin: 'auto',
                                borderRadius: '4px',
                            },
                        }}
                    >
                        <button className="close-btn" onClick={closeModal}><FontAwesomeIcon icon={faXmark} /></button>
                        <div className='h-full w-full'>
                            <EnquiryForm closeModal={closeModal} />
                        </div>
                    </Modal>
                </>
            )}
        </div>
    )
}

export default ContactModal;